<script lang="ts">
	import type { StoryCard } from '$lib/types/story';

	let { stories, emptyMessage = 'No stories found.' } = $props<{
		stories: StoryCard[];
		emptyMessage?: string;
	}>();
</script>

{#if stories.length > 0}
	<div class="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6">
		{#each stories as story}
			<a href="/story/{story.slug}" class="block space-y-2">
				<div class="relative aspect-[3/4] w-full overflow-hidden rounded-lg">
					<img
						src={story.images.fullSize}
						srcset="{story.images.storyCard150} 150w, {story.images.storyCard300} 300w, {story
							.images.storyCard600} 600w, {story.images.storyCard900} 900w, {story.images
							.storyCard1200} 1200w"
						alt={story.title}
						class="h-full w-full object-cover transition-transform duration-300 hover:scale-105"
					/>
				</div>
				<h3 class="line-clamp-2 text-sm font-medium">{story.title}</h3>
				<div class="flex flex-wrap gap-1">
					{#each story.labels as label}
						<span class="rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">
							{label.charAt(0).toUpperCase() + label.slice(1)}
						</span>
					{/each}
				</div>
			</a>
		{/each}
	</div>
{:else}
	<div class="flex min-h-[200px] items-center justify-center">
		<p class="text-center text-muted-foreground">{emptyMessage}</p>
	</div>
{/if}
